import { $ } from '../vendors/jquery';

class YoutubeVideo {
    constructor (element) {
        this.element = element;
        this.youtubeUrl = element.data('youtubeLink');
        this.youtubeId = this.youtubeParser(this.youtubeUrl);
        this.player = null;

        this.init();
    }

    init() {
        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);

        this.element.one('click', (e) => this.thumbnailClickHander(e));
    }

    thumbnailClickHander() {
      this.tag = document.createElement('script');
      this.tag.src = 'https://www.youtube.com/iframe_api';
      this.firstScriptTag = document.getElementsByTagName('script')[0];
      this.firstScriptTag.parentNode.insertBefore(this.tag, this.firstScriptTag);
    }

    youtubeParser(url) {
      const regExp =
        /^.*(youtu.be\/|youtube(-nocookie)?.com\/(v\/|.*u\/\w\/|embed\/|.*v=))([\w-]{11}).*/;
      const match = url.match(regExp);

      return match && 11 === match[4].length ? match[4] : false;
    }

    onYouTubeIframeAPIReady() {
      this.player = new window.YT.Player('player', {
        videoId: this.youtubeId,
        playerVars: {
          'playsinline': 1
        },
        events: {
          'onReady': this.onPlayerReady,
        }
      });
    }

    onPlayerReady(event) {
      event.target.playVideo();
    }
}

const youtubeVideo = {
    init() {
        const youtubeVideoElements = $('[data-module="youtube-video"]');

        if ( null !== youtubeVideoElements && youtubeVideoElements.length > 0) {
            youtubeVideoElements.each((index,element) => {
                new YoutubeVideo($(element));
            });
        }
    }
};

export default youtubeVideo;
